module.exports = {
  minWidthMd: 768,
  minWidthLg: 1024,
}
